(() => {
  const SELECTOR = '[data-exp-datepicker]';

  const WEEKDAYS = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];

  /** @param {Date} d */
  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  /** @param {Date} d */
  function formatSpanishLong(d) {
    const fmt = new Intl.DateTimeFormat('es-ES', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    const s = fmt.format(d);
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  /**
   * Monday-start week index: Monday=0..Sunday=6
   * @param {Date} d
   */
  function weekdayIndexMon0(d) {
    // JS: Sunday=0..Saturday=6
    const js = d.getDay();
    return (js + 6) % 7;
  }

  /**
   * @param {HTMLElement} root
   */
  function init(root) {
    if (root.__expDatepickerInit) return;
    root.__expDatepickerInit = true;

    const monthYearEl = root.querySelector('.exp-datepicker__month-year');
    const prevBtn = root.querySelector('[data-exp-prev]');
    const nextBtn = root.querySelector('[data-exp-next]');
    const gridEl = root.querySelector('.exp-datepicker__grid');
    const weekdaysEl = root.querySelector('.exp-datepicker__weekdays');
    const selectedLabelEl = root.querySelector('.exp-datepicker__selected-label');
    const hiddenInput = root.querySelector('input[type="hidden"][name="properties[Fecha de reserva]"]');

    if (!monthYearEl || !prevBtn || !nextBtn || !gridEl || !weekdaysEl || !selectedLabelEl || !hiddenInput) return;

    const form = root.closest('form');
    const addButton = form?.querySelector('button[name="add"], [name="add"][type="submit"]');

    const today = startOfDay(new Date());
    let viewDate = new Date(today.getFullYear(), today.getMonth(), 1);
    /** @type {Date | null} */
    let selectedDate = null;

    // Render weekdays header
    weekdaysEl.innerHTML = '';
    WEEKDAYS.forEach((w) => {
      const div = document.createElement('div');
      div.className = 'exp-datepicker__weekday';
      div.textContent = w;
      weekdaysEl.appendChild(div);
    });

    function syncButtonState() {
      if (!addButton) return;
      const hasValue = Boolean(hiddenInput.value);
      if (hasValue) {
        addButton.removeAttribute('disabled');
      } else {
        // ProductFormComponent in this theme checks getAttribute('disabled') === 'true'
        addButton.setAttribute('disabled', 'true');
      }
    }

    function setSelected(date) {
      selectedDate = date;
      hiddenInput.value = formatSpanishLong(date);
      selectedLabelEl.textContent = `Fecha seleccionada: ${hiddenInput.value}`;
      syncButtonState();
      render();
    }

    function clearSelected() {
      selectedDate = null;
      hiddenInput.value = '';
      selectedLabelEl.textContent = '';
      syncButtonState();
      render();
    }

    function render() {
      // Month title
      monthYearEl.textContent = new Intl.DateTimeFormat('es-ES', { month: 'long', year: 'numeric' }).format(viewDate);

      // Disable prev if it would go before current month (no past selection anyway)
      const prevMonth = new Date(viewDate.getFullYear(), viewDate.getMonth() - 1, 1);
      prevBtn.disabled = prevMonth < new Date(today.getFullYear(), today.getMonth(), 1);

      // Build grid
      gridEl.innerHTML = '';
      gridEl.setAttribute('role', 'grid');

      const year = viewDate.getFullYear();
      const month = viewDate.getMonth();
      const firstOfMonth = new Date(year, month, 1);
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const leadingBlanks = weekdayIndexMon0(firstOfMonth);

      // Leading blanks
      for (let i = 0; i < leadingBlanks; i++) {
        const blank = document.createElement('div');
        blank.className = 'exp-datepicker__day exp-datepicker__day--blank';
        blank.setAttribute('aria-hidden', 'true');
        blank.style.visibility = 'hidden';
        gridEl.appendChild(blank);
      }

      for (let day = 1; day <= daysInMonth; day++) {
        const date = startOfDay(new Date(year, month, day));
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'exp-datepicker__day';
        btn.textContent = String(day);
        btn.setAttribute('role', 'gridcell');

        const isPast = date < today;
        if (isPast) btn.disabled = true;

        const isSelected =
          selectedDate &&
          date.getFullYear() === selectedDate.getFullYear() &&
          date.getMonth() === selectedDate.getMonth() &&
          date.getDate() === selectedDate.getDate();

        btn.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        btn.setAttribute('aria-label', formatSpanishLong(date));

        btn.addEventListener('click', () => {
          if (btn.disabled) return;
          if (isSelected) {
            clearSelected();
          } else {
            setSelected(date);
          }
        });

        gridEl.appendChild(btn);
      }
    }

    prevBtn.addEventListener('click', () => {
      viewDate = new Date(viewDate.getFullYear(), viewDate.getMonth() - 1, 1);
      render();
    });

    nextBtn.addEventListener('click', () => {
      viewDate = new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 1);
      render();
    });

    // Initial state
    syncButtonState();
    render();
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach((root) => {
      if (root instanceof HTMLElement) init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // In case sections are re-rendered in theme editor
  document.addEventListener('shopify:section:load', boot);
})();

